import { Fragment } from 'react'
import { useTranslation } from 'next-i18next'

import { Tutor } from '~/types/tutoring-api'

import StudentTutorItem from '~/panels/components/StudentTutors/StudentTutorItem'

export default function StudentTutors({ tutors }: { tutors: Tutor[] }): React.ReactElement {
  const { t } = useTranslation('studentPanel')

  if (tutors.length === 0) {
    return (
      <div className="w-full md:w-80 h-full p-8 flex flex-col rounded shadow-large bg-gray-off-white">
        <h4 className="font-semibold text-md">{t('tutorPending')}</h4>
        <p className="my-auto py-4 text-xs text-gray-sub-text">{t('tutorPendingMessage')}</p>
      </div>
    )
  }

  return (
    <Fragment>
      {tutors.map((tutor, index) => (
        <Fragment key={tutor.id}>
          <StudentTutorItem
            avatarPngUrl={tutor.avatarPngUrl}
            description={tutor.description}
            email={tutor.email}
            fullName={tutor.fullName}
            institute={tutor.institute}
            phone={tutor.phone}
          />
          {index !== tutors.length - 1 && <div className="border-t border-gray-light" />}
        </Fragment>
      ))}
    </Fragment>
  )
}
